/*
  Auto-generated by Spline
*/

import useSpline from '@splinetool/r3f-spline'
import { PerspectiveCamera, OrthographicCamera, OrbitControls } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import React, { useRef } from 'react'


function Carrot({ ...props }) {
  const { nodes, materials } = useSpline('https://prod.spline.design/IJr6MxxEuItFLf1i/scene.splinecode')
  
  const carrotRef = useRef()

  useFrame(({ clock}) => {
    const elapsedTime = clock.getElapsedTime();  
    carrotRef.current.rotation.y = elapsedTime / 1;
  });
  
  
  return (
    <>
      <group {...props} dispose={null} >
        <directionalLight
          name="Directional Light"
          castShadow
          intensity={1}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-near={-10000}
          shadow-camera-far={100000}
          shadow-camera-left={-500}
          shadow-camera-right={500}
          shadow-camera-top={500}
          shadow-camera-bottom={-500}
          position={[-4220.02, 3352.97, 9.95]}
          rotation={[0, 0, 2.31]}
          scale={0.83}
        />
        <group ref={carrotRef}>
        <mesh
          name="Sphere 2"
          geometry={nodes['Sphere 2'].geometry}
          material={materials['Sphere 2 Material']}
          castShadow
          receiveShadow
          position={[36.26, 53.72, 369.63]}
          rotation={[-1.75, 0.05, 1.46]}
          scale={[0.66, 0.53, 0.61]}
        />
        <mesh
          name="Sphere 21"
          geometry={nodes['Sphere 21'].geometry}
          material={materials['Sphere 21 Material']}
          castShadow
          receiveShadow
          position={[49.76, 36, 362.01]}
          rotation={[-2.28, 0.59, 1.79]}
          scale={[0.64, 0.56, 0.6]}
        />
        <mesh
          name="Sphere 22"
          geometry={nodes['Sphere 22'].geometry}
          material={materials['Sphere 22 Material']}
          castShadow
          receiveShadow
          position={[31.73, 41.68, 387.57]}
          rotation={[2.06, 0.28, 1.44]}
          scale={[0.65, 0.52, 0.62]}
        />
        <mesh
          name="Sphere"
          geometry={nodes.Sphere.geometry}
          material={materials['Sphere Material']}
          castShadow
          receiveShadow
          position={[31.57, 3.16, 377.44]}
          rotation={[1.31, 1.26, 1.81]}
          scale={[0.14, 0.15, 0.11]}
        />
        <mesh
          name="Sphere 23"
          geometry={nodes['Sphere 23'].geometry}
          material={materials['Sphere 23 Material']}
          castShadow
          receiveShadow
          position={[56.53, 53.64, 386.55]}
          rotation={[1.49, -0.66, -1.46]}
          scale={[0.66, 0.59, 0.55]}
        />
        <mesh
          name="Sphere 3"
          geometry={nodes['Sphere 3'].geometry}
          material={materials['Sphere 3 Material']}
          castShadow
          receiveShadow
          position={[47.26, 55.19, 390.57]}
          rotation={[1.93, -0.14, 1.69]}
          scale={[0.65, 0.53, 0.61]}
        />
        <PerspectiveCamera
          name="1"
          makeDefault={true}
          far={100000}
          near={5}
          fov={45}
          position={[85.32, 16.44, 898.36]}
          rotation={[-0.02, 0.11, 0]}
          scale={1}
        />
        </group>
        <hemisphereLight name="Default Ambient Light" intensity={1.53} color="#eaeaea" />
        <OrbitControls
					enableZoom={true}
					enablePan={true}
					enableRotate={true}
					zoomSpeed={0.6}
					panSpeed={0.5}
					rotateSpeed={0.4}
				/>
      </group>
    </>
  )
}

export default Carrot